/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getAllBrands } from '../fn/om-brands/get-all-brands';
import { GetAllBrands$Params } from '../fn/om-brands/get-all-brands';
import { OmBrandsResponse } from '../models/om-brands-response';

@Injectable({ providedIn: 'root' })
export class OmBrandsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getAllBrands()` */
  static readonly GetAllBrandsPath = '/om/brands';

  /**
   * Gets all Order Manager brands.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllBrands()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllBrands$Response(params: GetAllBrands$Params, context?: HttpContext): Observable<StrictHttpResponse<OmBrandsResponse>> {
    return getAllBrands(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets all Order Manager brands.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllBrands$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllBrands(params: GetAllBrands$Params, context?: HttpContext): Observable<OmBrandsResponse> {
    return this.getAllBrands$Response(params, context).pipe(
      map((r: StrictHttpResponse<OmBrandsResponse>): OmBrandsResponse => r.body)
    );
  }

}
